import Vue from 'vue';

const state = {
    documentStatus: null,
    invoiceStatus: null,
    ticketStatus: null,
    lesseeStatus: null,
    transferUnitActivityLog: [],
    ticketLog: [],
    invoiceLog: [],
}

const mutations = {
    SET_DOCUMENT_STATUS(state, value) {
        state.documentStatus = value;
    },
    SET_INVOICE_STATUS(state, value) {
        state.invoiceStatus = value;
    },
    SET_TICKET_STATUS(state, value) {
        state.ticketStatus = value;
    },
    SET_LESSEE_STATUS(state, value) {
        state.lesseeStatus = value;
    },
    SET_TICKET_LOG(state, log) {
        state.ticketLog = log;
    },
    SET_INVOICE_LOG(state, value) {
        state.invoiceLog = value;
    },
}

const actions = {
    // Verification
    async getVerificationStatus({ commit }, { transferUnitId, type }) {
        commit('SET_LOADING', true);
        try {
            const response = await Vue.prototype.$http.post(process.env.GET_VERIFICATION_STATUS, {
                ltId: transferUnitId,
                type
            }, {
                headers: { 'Asani-Token': localStorage.getItem('jwt') }
            });
            if (response.data.status === 200) {
                switch (type) {
                    case 'lessee':
                        commit('SET_LESSEE_STATUS', response.data.content);
                        break;
                    case 'document':
                        commit('SET_DOCUMENT_STATUS', response.data.content);
                        break;
                    case 'invoice':
                        commit('SET_INVOICE_STATUS', response.data.content);
                        break;
                    case 'ticket':
                        commit('SET_TICKET_STATUS', response.data.content);
                        break;
                    default:
                        break;
                }
                return {
                    isSuccess: true,
                    data: response.data.content
                }
            }
            return {
                isSuccess: false,
                error: response.data.message,
                data: null
            }
        } catch (error) {
            return {
                isSuccess: false,
                error: "APP_ERROR",
                data: null
            }
        } finally {
            commit('SET_LOADING', false);
        }
    },
    async downloadTemplateApplicationDocument({ commit }, { transferUnitId, type, ltCode }) {
        commit('SET_LOADING', true);
        const payload = {
            ltId: transferUnitId,
            docType: type
        }
        try {
            const response = await Vue.prototype.$http.post(process.env.DOWNLOAD_TEMPLATE_DOC_TRANSFER_UNIT, payload, {
                headers: { 'Asani-Token': localStorage.getItem('jwt') },
            });
            if (response.data.status !== 200) {
                const errorMessage = response.data.message;
                return {
                    isSuccess: false,
                    message: errorMessage
                }
            }
            const base64String = response.data.content;
            const byteCharacters = atob(base64String);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            // its a word document
            const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = type === 'surat-permohonan' ?
                `Template Surat Permohonan Pengalihan - ${ltCode}.docx`
                : `Template Surat Persetujuan Pengalihan - ${ltCode}.docx`
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            return {
                isSuccess: true
            }
        } catch (error) {
            const errorMessage = error.response && error.response.data && error.response.data.message ? error.response.data.message : 'An error occurred while downloading the document.';
            return {
                isSuccess: false,
                message: errorMessage
            };
        } finally {
            commit('SET_LOADING', false);
        }
    },

    async uploadApplicationDocument({ commit }, payload) {
        commit('SET_LOADING', true);
        try {
            const response = await Vue.prototype.$http.post(process.env.UPLOAD_TRANSFER_APPLICATION_DOC, payload, {
                headers: {
                    'Asani-Token': localStorage.getItem('jwt')
                },
            });
            if (response.data.status !== 200) {
                const errorMessage = response.data.message;
                return {
                    isSuccess: false,
                    message: errorMessage
                }
            }
            return {
                isSuccess: true
            }
        } catch (error) {
            const errorMessage = error.response && error.response.data && error.response.data.message ? error.response.data.message : 'An error occurred while uploading the document.';
            return {
                isSuccess: false,
                message: errorMessage
            };
        } finally {
            commit('SET_LOADING', false);
        }
    },

    async getVerificationLog({ commit }, { transferUnitId, type }) {
        commit('SET_LOADING', true);
        const payload = {
            ltId: transferUnitId,
            type
        }
        try {
            const response = await Vue.prototype.$http.post(process.env.TRANSFER_UNIT_VERIFICATION_LOG, payload, {
                headers: { 'Asani-Token': localStorage.getItem('jwt') }
            });
            if (response.data.status !== 200) {
                const errorMessage = response.data.message;
                return {
                    isSuccess: false,
                    message: errorMessage
                }
            }
            const data = response.data.content || [];
            switch (type) {
                case 'lease':
                    commit('SET_TRANSFER_UNIT_ACTIVITY_LOG', data);
                    break;
                case 'invoice':
                    commit('SET_INVOICE_LOG', data);
                    break;
                case 'ticket':
                    commit('SET_TICKET_LOG', data);
                    break;
                default:
                    break;
            }
            return {
                isSuccess: true,
                content: data
            };
        } catch (error) {
            const errorMessage = error.response && error.response.data && error.response.data.message ? error.response.data.message : 'An error occurred while fetching the verification log.';
            return {
                isSuccess: false,
                message: errorMessage
            };
        } finally {
            commit('SET_LOADING', false);
        }
    },
}

const getters = {
    // Verification Getters
    getVerificationStatus: (state) => ({
        documentStatus: state.documentStatus,
        invoiceStatus: state.invoiceStatus,
        ticketStatus: state.ticketStatus,
        lesseeStatus: state.lesseeStatus
    }),
    getVerificationLogs: (state) => ({
        transferUnitActivityLog: state.transferUnitActivityLog,
        ticketLogs: state.ticketLog,
        invoiceLogs: state.invoiceLog
    }),
}

export default {
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/components/RentAdjustment/FormTabs/Verification/store.js